import {handleDownloadPdf} from "../utils/handlers/index.js";
import {v4 as uuidv4} from "uuid";
import {Button, Spinner} from "react-bootstrap";
import {MdDownload} from "react-icons/md";
import {useEffect, useState} from "react";
import PropTypes from "prop-types";
import {useGenerujPdf} from "../../api/domain/pdf/mutations/useGenerujjPdf.jsx";
import {usePdfStatus} from "../../api/domain/pdf/queries/useGetStatus.jsx";
import {toast} from "react-toastify";

const GenerujPdf = (props) => {

    const TIMEOUT_CHECK_IS_READY = 60000

    const [uuid, setUuid] = useState('')
    const [ready, setReady] = useState(false)
    const [isChecking, setIsChecking] = useState(false)
    const [loading, setLoading] = useState(false)

    const generujPdf = useGenerujPdf()
    const pdfStatus = usePdfStatus(`${props.pdfBodyData?.userType}/${props.module}`, uuid, !!uuid && isChecking)


    const download = () => handleDownloadPdf(
        props?.pdfBodyData?.id,
        props.pdfBodyData?.tmp,
        props.pdfBodyData?.userType,
        props.pdfBodyData?.wersja,
        props.module)


    const handleAction = async () => {
        if (!ready) {
            await handleGenerujPdf()
        } else {
            setReady(false)
            return download()
        }
    }

    const handleGenerujPdf = () => {
        const uuid = uuidv4()
        setLoading(true)
        setUuid(uuid)
        const form = {
            ...props.pdfBodyData,
            uuid: uuid
        }
        setIsChecking(true)
        generujPdf.mutate({url: `${props.pdfBodyData?.userType}/${props.module}/generuj-pdf`, form: form})
    }


    useEffect(() => {
        if (pdfStatus?.data?.data?.status === 'success') {
            setLoading(false)
            setReady(true)
            setIsChecking(false)
            download()
        } else if (pdfStatus?.data?.data?.status === 'failed') {
            setLoading(false)
            setIsChecking(false)
            toast.error('Nie udało się wygenerować PDF')
        }
        return () => {
            setLoading(false)
        }

        // eslint-disable-next-line
    }, [pdfStatus?.data?.data?.status])


    useEffect(() => {
        let timer
        if (isChecking) {
            timer = setTimeout(() => {
                toast.error('Nie udało się wygenerować PDF')
                if (isChecking) setIsChecking(false)
            }, TIMEOUT_CHECK_IS_READY);
        }
        return () => clearTimeout(timer);
    }, [isChecking]);

    return <>
        <br/>
        <Button
            className={'ms-2 float-start'}
            disabled={(loading || isChecking)}
            onClick={handleAction}> {(loading || isChecking) &&
            <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
            />} Pobierz podgląd PDF
            <MdDownload size={20}/>
        </Button>
        <br/>
        <div className={'float-none'}></div>
    </>

}

GenerujPdf.propTypes = {
    module: PropTypes.oneOf(['rejestr', 'sprawozdanie']).isRequired,
    pdfBodyData: PropTypes.object,//@ dane do wysłania
}

export default GenerujPdf